import { render } from "./Temp.vue?vue&type=template&id=fddce744"
import script from "./Temp.vue?vue&type=script&lang=js"
export * from "./Temp.vue?vue&type=script&lang=js"
script.render = render

export default script